import { withCurrentProductType } from '@common/withCurrentProductType';

import { EnterpriseSideNavBar, SideNavBarProps } from './components';
import { VerticalAppSideNavBar } from './VerticalAppSideNavbar';

export const SideNavBar = withCurrentProductType<SideNavBarProps>({
  Vertical: VerticalAppSideNavBar,
  Enterprise: EnterpriseSideNavBar
});
